import * as angular from "angular";
import { capitalise } from "./capitalise";
import { degreesToCompassTerm } from "./degreesToCompassTerm";
import { enumNames } from "./enumNames.filter";
import { formatNumberFilter } from "./formatNumber.filter.ajs";
import { minutesToDuration } from "./minutesToDurationFilter";
import { positiveFilter } from "./positive.filter";
import { splitPascalCase } from "./splitPascalCase.filter";
import { splitPascalCaseCustom } from "./splitPascalCaseCustom.filter";
import { trustedHtml } from "./trustedHtml.filter";
import { trustedSource } from "./trustedSource.filter";
import { minuteOfDayToTimeFilter } from "./minuteOfDayToTime.filter";
import { formatBytes } from "./formatBytes.filter";
import { translateFilter } from "./translate.filter.ajs";
import { markdownFilter } from "src/app/filters/markdown.filter";
import { phoneNumberFilter } from "./phoneNumber.filter.ajs";
import { unitConversionFilter } from "src/app/filters/unitConversion.filter.ajs";
import { veriDate } from "./veriDate.filter";
import { geocodeFilter } from "./geocode.filter";

angular
    .module("app.filters", [])

    .filter("formatNumber", formatNumberFilter)
    .filter("unitConversion", ["unitConversionService", unitConversionFilter])
    .filter("capitalise", capitalise)
    .filter("enumNames", enumNames)
    .filter("minutesToDuration", ["veriDate", minutesToDuration])
    .filter("positive", [positiveFilter])
    .filter("splitPascalCase", splitPascalCase)
    .filter("splitPascalCaseCustom", splitPascalCaseCustom)
    .filter("trustedHtml", ["$sce", trustedHtml])
    .filter("trustedSource", ["$sce", trustedSource])
    .filter("veriDate", ["veriDate", veriDate])
    .filter("geocode", ["geocodeService", "translationService", geocodeFilter])
    .filter("degreesToCompassTerm", ["plotService", degreesToCompassTerm])
    .filter("minuteOfDayToTime", [minuteOfDayToTimeFilter])
    .filter("translate", ["translationService", translateFilter])
    .filter("phoneNumberFilter",  phoneNumberFilter)
    .filter("markdown", ["$sce", markdownFilter])
    .filter("formatBytes", [formatBytes]);
